import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {Block} from '@travel-frontend/ui-components';

import beachHouseBackground from '@/assets/images/beach-house.png';
import mapBackground from '@/assets/images/map-background.svg';

type Props = {
  mapView: boolean;
};

export const Container = styled(Block)<Props>(
  ({theme, mapView}) => css`
    background-image: url('${mapView ? beachHouseBackground : mapBackground}');
    border: ${mapView ? 'none' : `1px solid ${theme.colors.borderPrimary}`};
    border-radius: ${mapView ? 'none' : '5px'};
    display: flex;
    justify-content: center;
    align-items: center;
    background-size: cover;
    background-position: center center;
    height: 100%;
    min-height: 64px;
    box-sizing: border-box;
  `
);
